var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"must-read-with-refresh__wrapper"},[_c('must-read',{key:_vm.$_lazyHydratedComponentState_getHydratedComponentRefreshKey(
        _vm.$options.consts.HYDRATED_SECTION_NAME
      ),attrs:{"last-modified":_vm.mustReadItemsLastModified,"must-read-items":_vm.mustReadItems},on:{"mounted":_vm.onMounted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }